import { render } from "./ellipsis.vue?vue&type=template&id=9d205e78&ts=true"
import script from "./ellipsis.vue?vue&type=script&lang=ts"
export * from "./ellipsis.vue?vue&type=script&lang=ts"

import "./ellipsis.vue?vue&type=style&index=0&id=9d205e78&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__